import { useRef } from "react";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import "./DateInput.scss";

const DateInputWithHighlight = ({
  placeholder = "YYYY-MM-DD",
  isRequired = false,
  label = null,
  labelDescription = null,
  errorMessage = undefined,
  supportedDeliveryDays = [],
  value = null,
  onChange = () => {},
}) => {
  const datepickerRef = useRef(null);

  const dayMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const allowedDays = supportedDeliveryDays.map((d) => dayMap[d]);

  const isDayDisabled = (date) => {
    const day = date.getDay();
    return !allowedDays.includes(day);
  };

  const handleIconClick = () => {
    if (datepickerRef.current) {
      datepickerRef.current.setOpen(true);
    }
  };

  return (
    <div className="date-input">
      {label && (
        <>
          <label>
            {isRequired && <span className="text-danger">*</span>}
            {label}
          </label>
          {labelDescription && (
            <span className="d-block gray--text smallest-text-size mb-1">
              {labelDescription}
            </span>
          )}
        </>
      )}

      <div className="datepicker-wrapper">
        <DatePicker
          ref={datepickerRef}
          selected={value instanceof Date ? value : null}
          onChange={(date) => {
            if (date instanceof Date && !isNaN(date)) {
              onChange(date);
            }
          }}
          placeholderText={placeholder}
          className={`custom-datepicker ${errorMessage ? "error-border" : ""}`}
          filterDate={(d) => !isDayDisabled(d)}
          dayClassName={(d) =>
            allowedDays.includes(d.getDay()) ? "highlight-day" : "disabled-day"
          }
          onChangeRaw={(e) => e.preventDefault()}
          dateFormat="yyyy-MM-dd"
        />
        <FontAwesomeIcon
          icon={faCalendarAlt}
          className="calendar-icon clickable"
          onClick={handleIconClick}
        />
      </div>

      {errorMessage && (
        <p className="error-message text-danger show">{errorMessage.message}</p>
      )}
    </div>
  );
};

export default DateInputWithHighlight;
